import React from 'react';
import { FormInstance, UploadFile } from 'antd';
import { DatePicker, UploadDragger, Form, Input } from '@common/components';
import { datetime, type DatetimeType } from '@common/services/datetime';

type Props = {
  form: FormInstance;
  onFormSubmit: (value: Record<string, string>) => void;
};

export const isBeforeEndOfToday = (current: DatetimeType): boolean =>
  current < datetime().endOf('day');

export function SuppliersManagementCreateFileForm({
  form,
  onFormSubmit,
}: Props) {
  const draggerProps = {
    name: 'file',
    action: '',
    text: 'Drag files to upload',
    beforeUpload() {
      return false;
    },
    onChange({ file }: { file: UploadFile }) {
      if (!form.getFieldValue('fileName')) {
        const fileName = file.name.split('.')[0];
        form.setFieldValue('fileName', fileName);
      }
    },
  };

  return (
    <Form layout="vertical" form={form} onFinish={onFormSubmit}>
      <Form.Item
        label="Name"
        name="fileName"
        rules={[{ required: true, message: 'Please type a file name' }]}
      >
        <Input size="large" placeholder="Type a file name" />
      </Form.Item>

      <Form.Item label="Expiration Date" name="expiresOn">
        <DatePicker
          placeholder="Select a date"
          format="MM/DD/YYYY"
          size="large"
          style={{ width: '50%' }}
          disabledDate={isBeforeEndOfToday}
        />
      </Form.Item>

      <Form.Item
        label="Upload"
        name="file"
        key="file"
        valuePropName="file"
        rules={[{ required: true, message: 'Please choose a file' }]}
      >
        <UploadDragger {...draggerProps} />
      </Form.Item>
    </Form>
  );
}
